module.exports = __webpack_public_path__ + "img/icon-tick-circle-positive.041c8bd0.svg";